<div class='overlay' *ngIf="showMask">
    <div class="text-center loader-block">
        <div class="preloader4">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
    </div>
</div>